import { Component } from '@angular/core';

@Component({
  selector: 'app-close-round',
  templateUrl: './close-round.component.html',
  styleUrls: ['./close-round.component.scss']
})
export class CloseRoundComponent {

}
